import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_VERTICALLY_CSAT, SUPERSET_VERTICALLY_CSAT_ERROR, SUPERSET_VERTICALLY_CSAT_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetVerticallyCSAT({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_VERTICALLY_CSAT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_VERTICALLY_CSAT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_VERTICALLY_CSAT_ERROR, payload: error });
  }
}

export function* watchSupersetVerticallyCSAT() {
  yield takeEvery(SUPERSET_VERTICALLY_CSAT, supersetVerticallyCSAT);
}

function* supersetVerticallyCSATSaga() {
  yield all([fork(watchSupersetVerticallyCSAT)]);
}

export default supersetVerticallyCSATSaga;
